import {
	ContainerOutlined,
	ReadOutlined,
	UsergroupAddOutlined
} from "@ant-design/icons";
import { Key, ReactNode } from "react";
import SafeLink from "../../components/link/SafeLink";
import { routesConfig } from "../../config/routes";
import { MenuItem } from "../../types/sidebar";

function getItem(
	label: ReactNode,
	key: Key,
	icon?: ReactNode,
	children?: MenuItem[],
	type?: string,
	permission?: string[]
): MenuItem {
	return {
		key,
		label,
		icon,
		children,
		type,
		permission,
	} as MenuItem;
}

export const courseManagementMenuItem = (courseId: string): MenuItem[] => [
	getItem(
		<SafeLink to={`${routesConfig.courseManagement}/${courseId}/${routesConfig.courseStudentList}`}>
			Học viên
		</SafeLink>,
		`${routesConfig.courseManagement}/${courseId}/${routesConfig.courseStudentList}`,
		<UsergroupAddOutlined />
	),
	getItem(
		<SafeLink to={`${routesConfig.courseManagement}/${courseId}/${routesConfig.gradingList}`}>
			Quản lý chấm điểm
		</SafeLink>,
		`${routesConfig.courseManagement}/${courseId}/${routesConfig.gradingList}`,
		<ReadOutlined />,
		undefined,
		undefined,
		undefined,
	),
	getItem(
		<SafeLink to={`${routesConfig.courseManagement}/${courseId}/${routesConfig.evaluationAndDiscussion}`}>
			Đánh giá và thảo luận
		</SafeLink>,
		`${routesConfig.courseManagement}/${courseId}/${routesConfig.evaluationAndDiscussion}`,
		<ReadOutlined />,
		undefined,
		undefined,
		undefined,
	),
];
